import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const feeInitialValues = {
  name: "",
  description: "",
  registrationPaymentId: 0,
  price: 0,
  currency: "",
  interval: "weekly",
  trialPeriodDays: 0,
  people: 1,
  discount: 0,
  repeatDiscount: 0,
  automatedTraining: false,
  automatedNutrition: false,
  app: false,
  centerAccess: false,
  installations: [],
  days: [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ],
  hourInit: {
    Monday: "00:00",
    Tuesday: "00:00",
    Wednesday: "00:00",
    Thursday: "00:00",
    Friday: "00:00",
    Saturday: "00:00",
    Sunday: "00:00",
  },
  hourFinish: {
    Monday: "23:59",
    Tuesday: "23:59",
    Wednesday: "23:59",
    Thursday: "23:59",
    Friday: "23:59",
    Saturday: "23:59",
    Sunday: "23:59",
  },
};

export const feeValidationSchema = Yup.object({
  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  description: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  registrationPaymentId: Yup.number().optional(),
  price: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  currency: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  interval: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  trialPeriodDays: Yup.number().optional(),
  people: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  discount: Yup.number().optional(),
  repeatDiscount: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  automatedTraining: Yup.boolean().required(FIELD_REQUIRED_MESSAGE),
  automatedNutrition: Yup.boolean().required(FIELD_REQUIRED_MESSAGE),
  app: Yup.boolean().required(FIELD_REQUIRED_MESSAGE),
  centerAccess: Yup.boolean().required(FIELD_REQUIRED_MESSAGE),
});

export type FeeValues = typeof feeInitialValues;


export const disabledFeeInitialValues = {
  fee_id: 0,
  dateInitial: '',
  dateEnd: '',
  days: '',
};

export const disabledFeeValidationSchema = Yup.object().shape({
  fee_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  dateInitial: Yup.date().required(FIELD_REQUIRED_MESSAGE),
  dateEnd: Yup.date().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.number().optional(),
});

export type DisabledFeeValues = typeof disabledFeeInitialValues;
